import type { infer as zInfer } from "zod";
import * as z from "zod";

export const getAmazonIntegration = {
  name: "getAmazonIntegration" as const,
  input: z.object({}),
  output: z.object({
    hasIntegration: z.boolean(),
    ordersSyncEnabled: z.boolean(),
    buyShippingEnabled: z.boolean(),
    hasBuyShippingAuthorization: z.boolean(),
    buyShippingCarrierAccount: z
      .object({ carrierAccountId: z.string(), name: z.string() })
      .nullable(),
  }),
};

export type AmazonIntegration = zInfer<typeof getAmazonIntegration.output>;
